/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getAreaInfo = /* GraphQL */ `query GetAreaInfo($input: getAreaInfoInput!) {
  getAreaInfo(input: $input) {
    areaId
    areaImagePath
    areaName
    explanation
    facilityId
    minFee
    sectionIds
    sectionImagePath
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAreaInfoQueryVariables,
  APITypes.GetAreaInfoQuery
>;
export const getAreaList = /* GraphQL */ `query GetAreaList($input: getAreaListInput!) {
  getAreaList(input: $input) {
    facilityId
    floorList {
      areaList {
        areaId
        areaImagePath
        areaName
        explanation
        minFee
        __typename
      }
      floor
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAreaListQueryVariables,
  APITypes.GetAreaListQuery
>;
export const getAreaReservationList = /* GraphQL */ `query GetAreaReservationList($input: getAreaReservationListInput!) {
  getAreaReservationList(input: $input) {
    areaReservationList {
      date
      isPublic
      reservationFlag
      reservationGroupName
      reservationStatus
      reservedEndTime
      reservedStartTime
      sectionId
      sectionName
      usagePurpose
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAreaReservationListQueryVariables,
  APITypes.GetAreaReservationListQuery
>;
export const getAreaUsageStatus = /* GraphQL */ `query GetAreaUsageStatus($input: getAreaUsageStatusInput!) {
  getAreaUsageStatus(input: $input) {
    areaId
    availability {
      availabilityList {
        reservationFlag
        reservedEndTime
        reservedStartTime
        __typename
      }
      date
      __typename
    }
    facilityId
    usageEndTime
    usageStartTime
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAreaUsageStatusQueryVariables,
  APITypes.GetAreaUsageStatusQuery
>;
export const getEmailFromToken = /* GraphQL */ `query GetEmailFromToken($input: getEmailFromTokenInput!) {
  getEmailFromToken(input: $input) {
    email
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEmailFromTokenQueryVariables,
  APITypes.GetEmailFromTokenQuery
>;
export const getEquipmentInfo = /* GraphQL */ `query GetEquipmentInfo($input: getEquipmentInfoInput!) {
  getEquipmentInfo(input: $input) {
    equipmentId
    equipmentImagePath
    equipmentName
    explanation
    rentalPriceList {
      rentalPrice
      rentalPriceDivision
      __typename
    }
    totalInventory
    typeInventory
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEquipmentInfoQueryVariables,
  APITypes.GetEquipmentInfoQuery
>;
export const getEquipmentList = /* GraphQL */ `query GetEquipmentList($input: getEquipmentListInput!) {
  getEquipmentList(input: $input) {
    category
    categoryName
    equipmentId
    equipmentImagePath
    equipmentName
    fullFlag
    rentalPriceList {
      rentalPrice
      rentalPriceDivision
      __typename
    }
    totalInventory
    typeInventory
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEquipmentListQueryVariables,
  APITypes.GetEquipmentListQuery
>;
export const getFacilityInfo = /* GraphQL */ `query GetFacilityInfo($input: getFacilityInfoInput!) {
  getFacilityInfo(input: $input) {
    facilityId
    facilityName
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFacilityInfoQueryVariables,
  APITypes.GetFacilityInfoQuery
>;
export const getGroupDetail = /* GraphQL */ `query GetGroupDetail($input: getGroupDetailInput!) {
  getGroupDetail(input: $input) {
    adress
    consecutiveReservationDays
    email
    groupName
    memo
    nameList01
    nameList02
    nameList03
    numberOfReservation
    registDate
    representative
    reservationLimit
    status
    tel
    version
    zipCode
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetGroupDetailQueryVariables,
  APITypes.GetGroupDetailQuery
>;
export const getReservationMasterData = /* GraphQL */ `query GetReservationMasterData($input: getReservationMasterDataInput!) {
  getReservationMasterData(input: $input) {
    usageDetailList {
      mandatoryEquipmentList
      usageDetail
      __typename
    }
    usageType
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetReservationMasterDataQueryVariables,
  APITypes.GetReservationMasterDataQuery
>;
export const getSample = /* GraphQL */ `query GetSample {
  getSample {
    sampleColumn1
    sampleColumn2
    sampleColumn3
    sampleKey
    __typename
  }
}
` as GeneratedQuery<APITypes.GetSampleQueryVariables, APITypes.GetSampleQuery>;
export const getSectionInfoList = /* GraphQL */ `query GetSectionInfoList($input: getSectionInfoListInput!) {
  getSectionInfoList(input: $input) {
    fee
    sectionId
    sectionName
    usageTimeFlag
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSectionInfoListQueryVariables,
  APITypes.GetSectionInfoListQuery
>;
export const getSectionUsageStatus = /* GraphQL */ `query GetSectionUsageStatus($input: getSectionUsageStatusInput!) {
  getSectionUsageStatus(input: $input) {
    areaId
    availableEndTime
    availableStartTime
    date
    facilityId
    sections {
      sectionId
      sectionName
      usageList {
        isPublic
        reservationFlag
        reservationGroupName
        reservationStatus
        reservedEndTime
        reservedStartTime
        usagePurpose
        __typename
      }
      usageTimeFlag
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSectionUsageStatusQueryVariables,
  APITypes.GetSectionUsageStatusQuery
>;
export const getSectionUsageStatusWithCondition = /* GraphQL */ `query GetSectionUsageStatusWithCondition(
  $input: getSectionUsageStatusWithConditionInput!
) {
  getSectionUsageStatusWithCondition(input: $input) {
    areaId
    date
    facilityId
    unavailableList {
      message
      reservationFlag
      reservedEndTime
      reservedStartTime
      sectionId
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSectionUsageStatusWithConditionQueryVariables,
  APITypes.GetSectionUsageStatusWithConditionQuery
>;
